module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isReady) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.showUpdateName) ? _c('div', {
    staticClass: "update-name-wrap"
  }, [_c('div', {
    staticClass: "guide-shadow"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-content"
  }, [_c('p', [_vm._v("系统检测到账号风险")]), _vm._v(" "), _c('p', [_vm._v("为了保护您的账户安全，请在完成总部管理员用户名修改后继续使用系统")]), _vm._v(" "), _c('div', {
    staticClass: "start-modify",
    on: {
      "click": _vm.modifyName
    }
  }, [_vm._v("开始修改")])])]) : (_vm.showLoginGuide) ? _c('comp-login-guide', {
    attrs: {
      "userInfo": _vm.userInfo
    }
  }) : [(_vm.isImgShow) ? _c('img', {
    staticClass: "img-guide",
    attrs: {
      "src": _vm.OrgGuideImg
    },
    on: {
      "click": function($event) {
        _vm.hideOrgImg()
      }
    }
  }) : _c('div', [(!_vm.isCRMUser) ? _c('NavBar') : _c('navbar-e', {
    attrs: {
      "userInfo": _vm.userInfo,
      "type": "HQ",
      "activeMenu": "chain"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body-content"
  }, [(!_vm.isCRMUser) ? _c('SideNav') : _c('SideNavCRM', {
    attrs: {
      "menus": _vm.menus
    }
  }), _vm._v(" "), _c('comp-bread-crumb', {
    attrs: {
      "items": _vm.breadCrumbs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('MessageNav'), _vm._v(" "), _c('div', {
    staticClass: "app-content"
  }, [_c('div', {
    staticClass: "content-inner-wrapper"
  }, [_c('keep-alive', {
    attrs: {
      "include": _vm.componentName
    }
  }, [_c('router-view')], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('comp-protocol', {
    attrs: {
      "protocol": _vm.protocol
    }
  })], _vm._v(" "), _c('UpdateName', {
    ref: "updateNameDialog"
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e795e3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 750
// module chunks = 8